import React, {  useCallback } from "react";
import { useSelector } from "react-redux";
import { Form  } from "semantic-ui-react";
import { AddBtn } from "../../../commonComponents/AddBtn";
import { FormTitle } from "../../../commonComponents/FormTitle";
import List from "../../../commonComponents/List";
import GuaranteeDetails from "./guaranteeDetails";
import { CustomLoader } from "../../../commonComponents/formComponents/loader";
import { useDocument } from "../../hooks/useDocument";

 const Guarantee=()=> {
   
  const {isLoading,AddItem,deleteItem,updateItem,saveItem}=useDocument({actionType:"PARTIES",tableName:"guarantee",containerKey:"parties"})
   
   const isFormEnabled=false
    const guaranteeDetails = useSelector((state) => state.Actor.guarantee)
    const renderItem=useCallback((item)=>{
     return  <GuaranteeDetails
     key={item.id}
     item={item}
     isFormEnabled={isFormEnabled}
     updateData={updateItem}
     deleteData={deleteItem}
     saveData={saveItem}
     />
    },[isFormEnabled,updateItem,deleteItem])
    return (
   
        <Form.Group className="float-container">
          <FormTitle title="Guarantee Details"
           boxNumber="8/2"
          >

          </FormTitle>
          <List renderItem={renderItem}
            dataSource={guaranteeDetails} 
          />
  
  { isLoading && <CustomLoader /> }
     {
      guaranteeDetails?.length<9 && <AddBtn id="addGuarantee" disabled={(isFormEnabled || isLoading)} onClick={()=>AddItem()} text="Add">
     

      </AddBtn>

     }
    
        </Form.Group>
     
    );
  }
  
  export default React.memo(Guarantee)